import React, { useEffect, useRef, useState } from "react";
import { isNullOrEmpty } from "../utilities";
import { DefaultButton, Label, Link, Panel, PanelType, PrimaryButton } from "@fluentui/react";
import { XDatePicker } from "./XDatePicker";
import { XComboBox } from "./XComboBox";
import { XTextField } from "./XTextField";
import { Grid } from "./Grid";
import { Row } from "./Row";
import { StandarDataTable } from "./StandarDataTable";
import { ValidationResult, validateObject, validator } from "../utilities/validations";
const div = (props, ...children) => {
    if (props == null) {
        props = {};
    }
    return React.createElement("div", { key: props.key }, children && children.map(o => o));
};
const grid = (props, ...children) => {
    if (props == null) {
        props = {};
    }
    if (typeof props.visible === 'boolean' && props.visible === false) {
        return void 0;
    }
    return React.createElement(Grid, { key: props.key }, children);
};
const row = (props, ...children) => {
    if (props == null) {
        props = {};
    }
    if (typeof props.visible === 'boolean' && props.visible === false) {
        return void 0;
    }
    return React.createElement(Row, { key: props.key }, children);
};
const col = (props, ...children) => {
    if (props == null) {
        props = {};
    }
    if (typeof props.visible === 'boolean' && props.visible === false) {
        return void 0;
    }
    const colLg = props.colLg || 12;
    const colMd = props.colMd || 12;
    const colSm = props.colSm || 12;
    const className = `ms-Grid-col ms-sm${colLg} ms-md${colMd} ms-lg${colSm}`;
    return React.createElement("div", { className: className, key: props.key }, children && children.map(o => o));
};
const Fragment = (props, ...children) => {
    return React.createElement(React.Fragment, null, children);
};
const textField = (props) => {
    if (props == null) {
        props = {};
    }
    return React.createElement(XTextField, { key: props.key, label: props.label || '', placeholder: props.placeholder || '', required: props.required || false, disabled: props.disabled || false, maxLength: props.maxLength || 0, onChange: value => props.onChanged(value), errorMessage: props.errorMessage || '', value: props.value || '', multiline: props.multiline || false });
};
const combobox = (props) => {
    if (props == null) {
        props = {};
    }
    if (typeof props.visible === 'boolean' && props.visible === false) {
        return void 0;
    }
    return React.createElement(XComboBox, { key: props.key, value: props.selectedKey, label: props.label || '', disabled: props.disabled || false, options: props.options || [], errorMessage: props.errorMessage || '', onChange: (value, item) => props.onChanged(value, item) });
};
const __props__ = (props) => {
    return props || {};
};
const datatable = (props) => {
    if (props == null)
        props = {};
    return React.createElement(StandarDataTable, { key: props.key, items: props.items || [], onItemsChanged: value => props.onChanged(value), onRenderItemPanel: (item, errors, setProperty) => {
            if (props.onRenderItem == null)
                return React.createElement("div", null, "No existe una funci\u00F3n de renderizado de registros");
            return props.onRenderItem(item, errors, setProperty);
        }, rowKey: x => x.Id, columns: props.columns || [], panelTitle: props.panelTitle, tableTitle: props.title, onValidate: (item) => {
            if (props.onValidateItem != null) {
                return props.onValidateItem(item);
            }
            else {
                return { isValid: true };
            }
        } });
};
const primaryButton = (props) => {
    if (props == null) {
        props = {};
    }
    return React.createElement(PrimaryButton, { key: props.key, text: props.text || '', primary: props.primary || true, onClick: () => {
            if (typeof props.onClick === 'function') {
                props.onClick();
            }
        } });
};
const defaultButton = (props) => {
    if (props == null) {
        props = {};
    }
    return React.createElement(DefaultButton, { key: props.key, text: props.text || '', primary: props.primary || false, onClick: () => {
            if (typeof props.onClick === 'function') {
                props.onClick();
            }
        } });
};
const label = (props) => {
    if (props == null)
        props = {};
    return React.createElement(Label, { key: props.key, styles: { root: props.styles || {} } }, props.text);
};
const link = (props) => {
    if (props == null)
        props = {};
    return React.createElement(Link, { key: props.key, href: props.href, onClick: props.onClick }, props.text);
};
const panel = (props, ...children) => {
    if (props == null) {
        props = {};
    }
    return React.createElement(Panel, { key: props.key, isOpen: props.isOpen || false, type: props.type || PanelType.smallFixedFar, headerText: props.headerText || '', isFooterAtBottom: props.isFooterAtBottom || true, onRenderFooterContent: () => {
            if (typeof props.onRenderFooterContent === 'function') {
                return props.onRenderFooterContent();
            }
            return React.createElement("div", null);
        }, hasCloseButton: false, closeButtonAriaLabel: props.closeButtonAriaLabel || '' }, children && children.map(o => o));
};
const promiseAll = async (promises, callback) => {
    const result = await Promise.all(promises);
    if (typeof callback === 'function') {
        callback.apply({}, result);
    }
};
const datePicker = (props) => {
    if (props == null) {
        props = {};
    }
    return React.createElement(XDatePicker, { key: props.key || '', label: props.label || '', onChange: value => props.onChanged(value), value: props.value || '', errorMessage: props.errorMessage || '', required: props.isRequired });
};
const createFunction = (code, variables) => {
    const variableNames = [];
    const variableValues = [];
    if (variables != null) {
        for (const key in variables) {
            if (Object.prototype.hasOwnProperty.call(variables, key)) {
                variableNames.push(key);
                variableValues.push(variables[key]);
            }
        }
    }
    const func = new Function('__props__', 'div', 'grid', 'Grid', 'row', 'Row', 'col', 'Col', 'textField', 'TextField', 'comboBox', 'ComboBox', 'datatable', 'DataTable', 'panel', 'Panel', 'primaryButton', 'PrimaryButton', 'defaultButton', 'Label', 'Link', 'PanelType', 'datePicker', 'DatePicker', 'promiseAll', 'isNull', 'isNullOrEmpty', 'Fragment', 'useState', 'useEffect', 'validator', 'ValidationResult', 'validateObject', ...variableNames, code)(__props__, div, grid, grid, row, row, col, col, textField, textField, combobox, combobox, datatable, datatable, panel, panel, primaryButton, primaryButton, defaultButton, label, link, PanelType, datePicker, datePicker, promiseAll, (value) => value == null, isNullOrEmpty, Fragment, useState, useEffect, validator, ValidationResult, validateObject, ...variableValues);
    return func;
};
export const FunctionHost = (props) => {
    const componentRef = useRef();
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const code = props.code;
        componentRef.current = createFunction(code, props.variables);
        setIsLoading(false);
    }, []);
    if (componentRef.current == null)
        return React.createElement("div", null, "Cargando componente....");
    return React.createElement(FunctionHostInternal, Object.assign({}, props, { component: componentRef.current }));
};
const FunctionHostInternal = (props) => {
    return props.component({
        value: props.value || {},
        onChanged: props.onChanged,
        state: props.state || {},
        errors: props.errors || {},
        onValidate: props.onValidate
    });
};
